<template>
  <el-form
    :model="ruleForm"
    status-icon
    :rules="rules"
    ref="ruleForm"
    class="demo-ruleForm"
  >
    <el-form-item prop="age">
      <el-input prefix-icon="el-icon-user" v-model="ruleForm.age"></el-input>
    </el-form-item>
    <el-form-item prop="pass">
      <el-input
        prefix-icon="el-icon-lock"
        type="password"
        v-model="ruleForm.pass"
        autocomplete="off"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <div class="loing_button_click">
        <button
          class="loing_button_clicks bottom_logint"
          type="primary"
          @click="submitForm('ruleForm')"
        >
          登录
        </button>
        <el-button
          class="loing_button_clicks bottom_login"
          type="primary"
          @click="getUpdate"
        >
          创建公司
        </el-button>
      </div>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  data() {
    var checkAge = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('账号不能为空'));
      }
      callback();
      // setTimeout(() => {
      //   if (!Number.isInteger(value)) {
      //     callback(new Error("请输入数字值"));
      //   } else {
      //     if (value < 18) {
      //       callback(new Error("必须年满18岁"));
      //     } else {
      //       callback();
      //     }
      //   }
      // }, 1000);
    };
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        callback();
      }
    };

    return {
      ruleForm: {
        pass: '',
        age: '',
      },
      rules: {
        pass: [{ validator: validatePass, trigger: 'blur' }],
        age: [{ validator: checkAge, trigger: 'blur' }],
      },
    };
  },
  methods: {
    submitForm(formName) {
      const _this = this;

      this.$refs[formName].validate((valid) => {
        if (valid) {
          const { pass, age } = this.ruleForm;
          console.log(this.$sha256(pass));
          this.$http
            .post(this.$userList.user_login, {
              password: this.$sha256(pass.toString()),
              user_name: age.toString(),
            })
            .then(
              (res) => {
                console.log(res);
                if (res.code === 200) {
                  if (res.data.token) {
                    localStorage.setItem('KC_token', res.data.token);
                    this.$emit('radioListS');
                  } else {
                    this.$alert('登录失败');
                  }
                } else {
                  if (res.message) {
                    _this.$alert(res.message);
                  }
                }
              },
              (res) => {
                console.info(res, '调用失败');
              }
            );
        } else {
          return false;
        }
      });
    },
    getUpdate() {
      this.$router.push({ path: '/login/update' });
    },
  },
};
</script>
<style scoped>
.loing_button_click {
  display: flex;
}
.loing_button_clicks {
  flex: 1;
  background: #1890ff;
}
.bottom_logint {
  /* background: #fff; */
  color: #ffffff;
  font-weight: 400;
  /* border: solid 1px #303133; */
  margin-left: 20px;
  border-radius: 5px;
}
.bottom_login {
  background: #fff;
  color: #303133;
  font-weight: 400;
  border: solid 1px #303133;
  margin-left: 20px;
  border-radius: 5px;
}
</style>
